<template>
  <footer class="bg-cover bg-black bg-center text-white py-8 footerbg-img">
    <div class="py-1 px-8 max-w-screen-2xl mx-auto">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        <div class="flex flex-col items-start">
          <div class="flex flex-col items-start space-y--20 -mt-3">
             <!-- Logo -->
        <div class="flex items-center">
          <router-link to="/" class="group">
            <div class="flex items-center space-x-3">
              <div class="w-12 h-12 bg-yellow rounded-full flex items-center justify-center shadow-lg group-hover:shadow-purple-500/25 transition-all duration-300">
                <span class="text-white font-bold text-xl">M</span>
              </div>
              <span class="text-white text-xl font-semibold tracking-wide">Mshel Foundation</span>
            </div>
          </router-link>
        </div>
                <div class=" items-center pt-16">

            <p class="text-sm hidden md:block leading-snug -mt-11">
              At Mshel Foundation, we are dedicated to empowering communities
              through impactful initiatives.
            </p>
            </div>
          </div>

          <div class="flex gap-3 mt-4">
            <a
              href="https://www.facebook.com/MshelHomes/"
              class="p-2 w-8 h-8 flex items-center justify-center border border-white rounded-full hover:bg-yellow hover:text-white hover:border-none"
            >
              <i class="fa-brands fa-facebook"></i>
            </a>
            
            <a
              href="https://www.youtube.com/@mshelhomes"
              class="p-2 w-8 h-8 flex items-center justify-center border border-white rounded-full hover:bg-yellow hover:text-white hover:border-none"
            >
              <i class="fa-brands fa-youtube"></i>
            </a>
            <a
              href="https://www.instagram.com/mshelhomes/"
              class="p-2 w-8 h-8 flex items-center justify-center border border-white rounded-full hover:bg-yellow hover:text-white hover:border-none"
            >
              <i class="fa-brands fa-instagram"></i>
            </a>
            <a
              href="https://twitter.com/mshelofficial"
              class="p-2 w-8 h-8 flex items-center justify-center border border-white rounded-full hover:bg-yellow hover:text-white hover:border-none"
            >
              <i class="fa-brands fa-twitter"></i>
            </a>
            
          </div>
        </div>

        <div>
          <p class="font-semibold text-lg">Address</p>
          <p class="text-sm mt-6">
            The Mshel Hub, No. 2 Julius Adelusi Street, Guzape, Abuja.
          </p>
        </div>

        <div>
          <p class="font-semibold text-lg mb-6">Email</p>
          <a
            href="mailto:info@mshelhomes.com"
            class="block text-sm hover:text-yellow-500"
            >info@mshelfoundation.com</a
          >
          <a
            href="mailto:mshelhomes@gmail.com"
            class="block text-sm hover:text-yellow-500"
            >mshelfoundation@gmail.com</a
          >
        </div>

        <div>
          <p class="font-semibold text-lg mb-6">Phone</p>
          <a
            href="tel:+2348104444229"
            class="block text-sm hover:text-yellow-500"
            >+234-810-444-4229</a
          >
          <a
            href="tel:+2348123333326"
            class="block text-sm hover:text-yellow-500"
            >+234-812-333-3326</a
          >
        </div>
      </div>

      <div
        class="flex flex-col md:flex-row justify-between items-center mt-10 border-t border-gray-500 pt-4 text-sm"
      >
        <p>© 2025 Mshel Foundation. Designed by Mshel Integrated Systems</p>
        <router-link
          to="/privacy-policy"
          @click="scrollToTop"
          class="hover:text-yellow-500"
          >Privacy Policy</router-link
        >
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterSection",
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style scoped>
/* .footerbg-img {
  background-image: url('@/assets/images/young-african-boy-and-his-friend-girl-of-mixed-r-2024-12-06-07-44-04-utc.jpg');
  background-size: cover;
  background-position: center;
} */

 .w-28{
  width: 12rem; /* Adjusted for better responsiveness */
 }
</style>
